module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2",
    attrs: {
      "id": "ch00_fm06_con"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_vii"
    }
  }), _c('strong', [_vm._v("Contents")])]), _vm._v(" "), _c('p', {
    staticClass: "etoc"
  }, [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch00_fm07_pre#ch00_fm07_pre"
    }
  }, [_c('em', [_vm._v("Preface")])])]), _vm._v(" "), _c('p', {
    staticClass: "etoc"
  }, [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch00_fm08_ack#ch00_fm08_ack"
    }
  }, [_c('em', [_vm._v("Acknowledgments")])])]), _vm._v(" "), _c('p', {
    staticClass: "etoc1"
  }, [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch00_fm09_half1#ch00_fm09_half1"
    }
  }, [_vm._v("When Germs and People Interact: An Introduction")])]), _vm._v(" "), _c('p', {
    staticClass: "etoc2"
  }, [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch00_fm10_part01#ch00_fm10_part01"
    }
  }, [_c('strong', [_vm._v("P"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ART")]), _vm._v(" I Which Germs Where?")])])]), _vm._v(" "), _c('p', {
    staticClass: "etoc1"
  }, [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch01#ch01"
    }
  }, [_c('strong', [_vm._v("1")]), _vm._v(" I’m Hungry! Food-Borne Germs and Food Preparation Safety")])]), _vm._v(" "), _c('p', {
    staticClass: "etoc1"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch02#ch02",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("2")]), _vm._v(" A, B, C and 1, 2, 3: Common Germs at Day Care and School")])]), _vm._v(" "), _c('p', {
    staticClass: "etoc1"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch03#ch03",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("3")]), _vm._v(" Swim, Ski, or Wrestle: Germs Encountered When Playing Sports")])]), _vm._v(" "), _c('p', {
    staticClass: "etoc1"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch04#ch04",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("4")]), _vm._v(" Fur, Feathers, and Fangs: Germs from Pets and Other Animals")])]), _vm._v(" "), _c('p', {
    staticClass: "etoc1"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch05#ch05",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("5")]), _vm._v(" The Great Outdoors: Germs in the Garden, at the Campground, on the Farm, and at the Beach")])]), _vm._v(" "), _c('p', {
    staticClass: "etoc1"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch06#ch06",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("6")]), _vm._v(" Close to Home and Overseas: Tips for Avoiding Germs When You Travel")])]), _vm._v(" "), _c('p', {
    staticClass: "etoc1"
  }, [_c('a', {
    attrs: {
      "id": "page_viii"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch07#ch07",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("7")]), _vm._v(" Sexually Transmitted Infections, Tattoos, and Piercings: Helping Teenagers Navigate Germs Safely")])]), _vm._v(" "), _c('p', {
    staticClass: "etoc2"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch07_part02#ch07_part02",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("P"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ART")]), _vm._v(" II Our Defenses against Germs")])])]), _vm._v(" "), _c('p', {
    staticClass: "etoc1"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch08#ch08",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("8")]), _vm._v(" Taking Medicine: The Use and Misuse of Antibiotics")])]), _vm._v(" "), _c('p', {
    staticClass: "etoc1"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch09#ch09",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("9")]), _vm._v(" The Miracle of Modern Prevention: Vaccine Safety and Effectiveness")])]), _vm._v(" "), _c('p', {
    staticClass: "etoc1"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch10#ch10",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("10")]), _vm._v(" Baby’s on the Way: Protect Your Unborn Baby with a Healthy Pregnancy")])]), _vm._v(" "), _c('p', {
    staticClass: "etoc1"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch11#ch11",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("11")]), _vm._v(" Bonding with Your Baby: The Benefits of Breastfeeding")])]), _vm._v(" "), _c('p', {
    staticClass: "etoc1"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch12#ch12",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("12")]), _vm._v(" Supplements, Herbs, Organic Produce, and Probiotics: Do They Protect You from Germs?")])]), _vm._v(" "), _c('p', {
    staticClass: "etoc1"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch13#ch13",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("13")]), _vm._v(" Wash Your Hands! Personal and Household Hygiene for the Twenty-first Century")])]), _vm._v(" "), _c('p', {
    staticClass: "etoc1"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch14#ch14",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("14")]), _vm._v(" Myths and Truths: Does Science Back Up Traditional Wisdom about Preventing Infections?")])]), _vm._v(" "), _c('p', {
    staticClass: "etoc1"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch15_aft#ch15_aft",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Afterword")])]), _vm._v(" "), _c('p', {
    staticClass: "etoc"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch16_tru#ch16_tru",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Trustworthy Web Resources")])])]), _vm._v(" "), _c('p', {
    staticClass: "etoc"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch17_sele#ch17_sele",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Selected Bibliography")])])]), _vm._v(" "), _c('p', {
    staticClass: "etoc"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch18_index#ch18_index",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Index")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-21d60d88","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/ch00_fm06_con.vue
// module id = 75
// module chunks = 0